<template>
  <v-app-bar>
    <template #prepend>
      <div class="relative">
        <RittalLogo
          :class="`origin-center duration-300 h-16 w-32 fixed object-contain z-[1060] px-2 py-4 `"
          id="rittal-logo"
          v-show="isMounted"
          :no-fill="!fillLogo"
        ></RittalLogo>
        <div
          id="scrim"
          :class="`w-screen bg-color h-screen fixed z-[1050] top-0 flex justify-end items-end ${
            doneLoading ? 'pointer-events-none' : 'pointer-events-auto'
          }`"
        ></div>
      </div>
    </template>
    <template #append>
      <v-select
        prepend-inner-icon="mdi-translate"
        aria-label="Select Language"
        hide-details
        density="compact"
        :items="['Deutsch', 'English']"
        id="language"
        variant="solo"
        :model-value="
          applicationStore.language === 'de' ? 'Deutsch' : 'English'
        "
        @update:model-value="
          (val) => applicationStore.setLanguage(val === 'Deutsch' ? 'de' : 'en')
        "
        :title="i18n.global.t('global.language')"
      >
      </v-select>
      <v-btn
        aria-label="Open Application Settings"
        class="!min-w-9"
        @click="
          applicationStore.sideNavbarOpen = !applicationStore.sideNavbarOpen
        "
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </template>
  </v-app-bar>
</template>
<script setup lang="ts">
// vue
import { onMounted, ref, watch } from "vue";
// helpers
import { i18n } from "@/locales";
import * as animationHandler from "@/helpers/handleAnimations";
// store
import { useApplicationStore, useSystemStore, useUserStore } from "@/store";
// components
import RittalLogo from "@/components/RittalLogo.vue";

// store instances
const applicationStore = useApplicationStore();
const systemStore = useSystemStore();
const userStore = useUserStore();

// variables for transitions
const doneLoading = ref(false);
const fillLogo = ref(false);
const isMounted = ref(false);

onMounted(() => {
  isMounted.value = true;
  animationHandler.appMounted({ fillLogoRef: fillLogo });
  if (applicationStore.skipEntryAnimation) animationHandler.skipAnimation();
});

// handle done variable on system
watch(
  () => systemStore.loadingState,
  () => {
    if (
      systemStore.loadingState == "loading" ||
      systemStore.loadingState == "unset"
    )
      return;
    if (!doneLoading.value) {
      doneLoading.value = true;
      animationHandler.appLoaded();
    }
  }
);
watch(
  () => userStore.loadingState,
  (state) => {
    if (
      state == "loading" ||
      state == "unset"
    )
      return;
    if (!doneLoading.value) {
      doneLoading.value = true;
      animationHandler.appLoaded();
    }
  }
);
</script>
<style lang="scss" scoped></style>
